<template>
    <div class="App">
        <div
            v-if="loaded"
            class="App-mainContainer"
        >
            <Container />
        </div>
    </div>
</template>

<script>
import {loadLanguageAsync} from "@/i18n/i18n";
import Container from '@/pages/Container.vue';

export default {
    components: {
        Container
    },
    data(){
        return {
            loaded: false
        }
    },
    mounted() {
        loadLanguageAsync({
            language: this.$language,
            country: this.$country,
            baseUrl: this.$baseUrl,
        }).finally(() => {
            this.loaded = true;
        });
    }
};
</script>

<style lang="scss" scoped>
.slide-fade-enter-active, .slide-fade-leave-active,
.slide-fade-loader-enter-active, .slide-fade-loader-leave-active,
.hidden {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to,
.slide-fade-loader-enter, .slide-fade-loader-leave-to,
.hidden {
  transform: translateX(50px);
  opacity: 0;
}
.slide-fade-enter-active, .hidden{
  transition-delay: .3s;
}
.slide-fade-loader-leave-active{
  transition-delay: .3s;
}

.App{


  &-whiteSymbol {
    position: absolute;
    top: 0;
    left: 0;
    width: 500px;
    height: 500px;
    @media only screen and (max-width: $f2m-desktop-breakpoint) {
      display: none;
    }
  }


  .loaderContainer{
    width: 100%;
    display:flex;
    justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    border-radius: 0;

    .Loader{
      width: 200px;
    }
  }

  &-menu{
    z-index: 10000;
  }
}
.loaderContainer{
  position: fixed;
}

</style>
